export const changeFilterNames = filterTypes =>
  filterTypes.map(type => {
    switch (type) {
      case 'studios':
        return 'studio';
      case 'rooms':
        return 'roomShared';
      case 'residences':
        return 'residence';
      case 'apartments':
        return 'whole';
      default:
        return type;
    }
  });

export default { changeFilterNames };
